import Promotion26UpAContainer from "@/containers/Promotion/Promotion26UpAContainer";

export default function Promotion26UpAPage() {
  return <Promotion26UpAContainer />;
}
